(() => {
  document.addEventListener('keyup', (e) => {
    if (e.key !== ' ') {
      return;
    }

    const elem = window.swinger.eventHub.getTarget(e).closest('[role="button"]:not(button)');

    if (!elem) {
      return;
    }

    elem.click();
  });
})();
